import React from "react";

import * as Styles from "./styles";

interface Props {
  value: number;
  onChangeValue: (value: number) => void;
}

const SelectVisitaRetorno: React.FC<Props> = (props) => {
  return (
    <Styles.Container>
      <Styles.Button
        isActive={props?.value === 1}
        onClick={() => props?.onChangeValue(1)}
      >
        <Styles.ButtonText isActive={props?.value === 1}>
          Visita
        </Styles.ButtonText>
      </Styles.Button>
      <Styles.Button
        isActive={props?.value === 2}
        onClick={() => props?.onChangeValue(2)}
      >
        <Styles.ButtonText isActive={props?.value === 2}>
          Retorno
        </Styles.ButtonText>
      </Styles.Button>
      <Styles.Button
        isActive={props?.value === 3}
        onClick={() => props?.onChangeValue(3)}
      >
        <Styles.ButtonText isActive={props?.value === 3}>
          Videochamada
        </Styles.ButtonText>
      </Styles.Button>
    </Styles.Container>
  );
};

export default SelectVisitaRetorno;
